import { useAtom } from "jotai";
import { useSendAnalyticsEvent } from "../analytics/events";
import { MenuItem } from "../components/Menu";
import { blocksRefAtom, currentUserAtom } from "../jotai/atoms";
import { UpsertBlock } from "../liveblocks/maps";
import { AnyBlock } from "../types";
import { importBlocks } from "./InitParamLoader";

export function handleDroppedBlockData(
  upsertBlock: UpsertBlock,
  e: DragEvent,
  items: DataTransferItemList
) {
  const reader = new FileReader();
  reader.onloadend = function () {
    try {
      const data = JSON.parse((this.result || "{}").toString());
      importBlocks(data, upsertBlock);
    } catch (e) {
      console.error("unknown file drop", e);
    }
  };

  const file = e.dataTransfer?.files[0];
  if (file && items[0].type.includes("json")) reader.readAsText(file);
}

export default function ExportJSON() {
  const sendAnalyticsEvent = useSendAnalyticsEvent();
  const [currentUser] = useAtom(currentUserAtom);
  const [blocksRef] = useAtom(blocksRefAtom);
  if (!currentUser) return null;

  const exportJSON = () => {
    const _blocks: Record<string, AnyBlock> = {};
    for (const key in blocksRef.current) {
      _blocks[key] = blocksRef.current[key];
    }

    sendAnalyticsEvent({ name: "exportedBlocksAsJSON" });

    const a = document.createElement("a");
    const json = JSON.stringify(_blocks),
      blob = new Blob([json], { type: "octet/stream" }),
      url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = "blocks.json";
    a.click();
    window.URL.revokeObjectURL(url);
  };
  return <MenuItem onSelect={exportJSON}>Export blocks as JSON</MenuItem>;
}
